// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2IzNP","inner":"Form_inner__3JTXB","range":"Form_range__27NI0","name":"Form_name__1v1wH","actions":"Form_actions__3uJoP"};